import React from "react";
import PropTypes from "prop-types";
import { DeliveryDatetimePropType } from "./SlotSelectorDatetime";
import moment from "moment";
import { weekdayNames } from "../Format";

const SlotSelectorDate = (props) => {
    const generate_dates = () => {
        let dates = props.slots.map((date) => date.moment.substr(0, 10));
        dates = dates.filter((item, index) => dates.indexOf(item) === index);
        return dates.map((item) => moment(item));
    };

    const weekday_label = (date) => {
        if (date.isoWeekday() === moment().isoWeekday()) return "heute";
        if (date.isoWeekday() === moment().add(1, "days").weekday())
            return "morgen";
        return weekdayNames[date.isoWeekday()];
    };

    return (
        <select
            id="delivery-date"
            name="delivery-date"
            value={props.currentDate}
            onChange={(evt) => props.selectDate(evt.target.value)}
        >
            {generate_dates().map((date) => (
                <option key={`date-${date}`} value={date.format("YYYY-MM-DD")}>
                    {weekday_label(date)}, der {date.format("DD.MM.YYYY")}
                </option>
            ))}
        </select>
    );
};

SlotSelectorDate.propTypes = {
    currentDate: PropTypes.string,
    selectDate: PropTypes.func,
    slots: PropTypes.arrayOf(PropTypes.shape(DeliveryDatetimePropType)),
};

export default SlotSelectorDate;
